let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("rY6Jk")).then(() => parcelRequire('8Xpvo'));